//import { Component, OnInit } from '@angular/core';

//@Component({
//  selector: 'app-e-eot',
//  templateUrl: './e-eot.component.html',
//  styleUrls: ['./e-eot.component.css']
//})
//export class EEotComponent implements OnInit {

//  constructor() { }

//  ngOnInit(): void {
//  }

//}

import { Component, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../apiservices.service';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  selector: 'app-e-eot',
  templateUrl: './e-eot.component.html',
  styleUrls: ['./e-eot.component.css']
})
export class EEotComponent implements OnInit {

  //UI Status Variables
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Input Variables
  TINInput: any = "";
  AgentInput: any = "";
  SearchTypeInput: any = "";
  FormTypeInput: any = "";

  //UI View Variables
  TINView: any = "";
  ItGrpCdView: any = "";
  TaxpNameView: any = "";
  SearchTypeView: any = "";

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionLanguage: any = "";

  //Array Variables
  AgentList: any = new Array;

  //Datatable
  displayedColumns = ['jenisborang', 'tahun', 'action'];

  //Open Window
  openedWindowStatus: any = null;

  constructor(private apiServices: ApiservicesService, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionLanguage = sessionStorage.getItem('Language');
  }
  onChangeIDType() {
    this.SearchStatus = false;
    this.ResetValue();
  }
  ResetValue() {
    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";
    this.SearchTypeView = "";

    this.TINInput = "";
    this.AgentInput = "";
  }
  async Submit(SearchType: any, TIN: any) {
    this.LoaderStatus = true;
    if (SearchType === "" || TIN === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      this.SearchTypeView = SearchType;
      let Params;
      if (SearchType === "6") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "itRefNo": Number(TIN),
          "formType": "EOT"
        };
      }
      else if (SearchType === "7") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "newEmplRefNo": Number(TIN),
          "formType": "EOT"
        };
      }
      const result = await this.apiServices.SharedIntegrationDetail(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        this.GetAgent(this.SessionFirmID);
        this.TINView = result.taxPayer.iT_Ref_No;
        this.ItGrpCdView = result.taxPayer.jenisFail;
        this.TaxpNameView = result.taxPayer.nama;
        this.SearchStatus = true;
        this.LoaderStatus = false;
      }
    }
  }

  async Login(SearchType: any, TIN: any, AgentID: any) {
    this.LoaderStatus = true;
    if (AgentID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih ejen cukai";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params;
      if (SearchType === "6") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "itRefNo": Number(TIN),
          "staffID": Number(this.SessionStaffID),
          "taxAgentID": Number(AgentID),
          "formType": "EOT",
          "language": this.SessionLanguage
        };
      } else if (SearchType === "7") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "newEmplRefNo": Number(TIN),
          "staffID": Number(this.SessionStaffID),
          "taxAgentID": Number(AgentID),
          "formType": "EOT",
          "language": this.SessionLanguage
        };
      }
      const result = await this.apiServices.SharedIntegrationLogin(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
        this.TINView = "";
        this.ItGrpCdView = "";
        this.TaxpNameView = "";
        this.SearchTypeView = "";

        this.TINInput = "";
        this.AgentInput = "";
        this.SearchTypeInput = "";

      } else {
        this.openWindow(result.url);
        //window.open(result.url, "_blank");
        this.LoaderStatus = false;
      }
    }
  }
  async GetAgent(FirmID: any) {
    let Params = {
      "FirmID": FirmID,
      "Role": "0204",
      "NonExpiredTaxAgent": false
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }
  Semula() {
    this.LoaderStatus = false;
    this.SearchStatus = false;
    this.AlertStatus = false;

    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";
    this.SearchTypeView = "";

    this.TINInput = "";
    this.AgentInput = "";
    this.SearchTypeInput = "";
  }
  openWindow(URL: any) {

    console.log("URL IS " + URL);

    if (this.openedWindowStatus === null || this.openedWindowStatus.closed) {
      this.openedWindowStatus = window.open(URL, "_blank");
      console.log("1");
    }

    else {
      this.openedWindowStatus.focus();
      console.log("2");
    }

  }

  onTinChange(value: string) {
    // Fallback sanitizer (covers autofill, drag-drop, etc.)
    this.TINInput = (value || '').replace(/\D/g, '').slice(0, 12);
  }

  allowDigitsOnly(event: KeyboardEvent) {
    const key = event.key;

    // Allow control/navigation keys
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];

    if (allowedKeys.includes(key) || event.ctrlKey || event.metaKey) {
      return;
    }

    // Block non-digits
    if (!/^\d$/.test(key)) {
      event.preventDefault();
      return;
    }

    // Enforce max 12
    if ((this.TINInput?.length || 0) >= 12) {
      event.preventDefault();
    }
  }

  onPasteDigitsOnly(event: ClipboardEvent) {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') ?? '';
    const digits = pastedText.replace(/\D/g, '');

    const current = this.TINInput || '';
    const remaining = 12 - current.length;

    if (remaining <= 0) return;

    this.TINInput = current + digits.slice(0, remaining);
  }
}
